import { render, staticRenderFns } from "./EditProject.vue?vue&type=template&id=0347ef0e"
import script from "./EditProject.vue?vue&type=script&lang=js"
export * from "./EditProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports